import React, { useRef } from "react";
import { Carousel } from "react-bootstrap";
import { Link } from "react-router-dom";
import laptop from "../../../assets/images/app_laptop_bg.png";
import windows_logo from "../../../assets/images/windows-logo.png";
import linux_logo from "../../../assets/images/linux-logo.png";
import apple_logo from "../../../assets/images/apple-logo.svg";
import download from "../../../assets/images/download.svg";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons'
import Faq from "./Faq";
import { isLogIn } from "../../../config/Api";
import { Helmet } from "react-helmet";

let os = [
    { name: "Windows", caption: "Windows 10, 11", image: windows_logo, link: [{ "format": ".exe", "url": "https://api.pngcompressor.com/public/updates/pngcompressor.exe" }] },
    { name: "Mac", caption: "macOS10.15+", image: apple_logo, link: [{ "format": ".dmg", "url": "https://api.pngcompressor.com/public/updates/pngcompressor.dmg" }] },
    {
        name: "Linux", caption: "Debian, Ubuntu", image: linux_logo, link: [
            { "format": ".deb", "url": "https://api.pngcompressor.com/public/updates/pngcompressor-arm64.deb" },
            { "format": ".rpm", "url": "https://api.pngcompressor.com/public/updates/pngcompressor-aarch64.rpm" }
        ]
    },
]

const DesktopApp = () => {
    const sectionRef = useRef(null);

    const handleScroll = () => {
        sectionRef.current?.scrollIntoView({ behavior: "smooth" });
    };
    return (
        <>
            <Helmet>
                <title>Download PNG Compressor Desktop App! It's Free.</title>
            </Helmet>
            <div className="wrdprsspgehdr ">
                <div className="container">
                    <div className="header-bnr">
                        <div className="row">
                            <div className="col-lg-6">
                                <div className="header-txt-hldr text-left downloadapp_banner">
                                    <h1>Download PNG Compressor<br /> Desktop App</h1>
                                    <h4>Fast. Simple. Powerful.</h4>
                                    <p className="mb-3">Say goodbye to bulky image files and hello to seamless compression with our desktop app. Whether you're a designer, content creator, or just managing storage, our tool helps you:</p>
                                    <ul className="bullet_list">
                                        <li>Compress images without losing quality</li>
                                        <li>Batch process entire folders in seconds</li>
                                        <li>Optimize for web, email, or social media</li>
                                        <li>Support for JPG, PNG & more</li>
                                    </ul>
                                    <p><strong>Lightweight, user-friendly, and totally offline</strong> — your images stay private and your workflow stays fast.</p>
                                    <button onClick={handleScroll} className="btn-cmn btn-grn">Download now</button>
                                </div>

                            </div>
                            <div className="col-lg-6">
                                <div className="header-imghldr  ">
                                    <img src={laptop} className="" alt="" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="pluginfeatures" ref={sectionRef}>
                <div className="container">
                    {/* <div className="col-md-11 midcolumn">
                        <div className="heading_row">
                            <strong>Download Our Desktop App</strong>
                        </div>
                    </div> */}
                    <div className="clearfix pricing_mod lightSlider downloadapp_block" id="upgrade_plan">
                        <div className="row">
                            {os.length > 0 && os.map((data, index) => {
                                return (
                                    <div className="col-4" key={index.toString()}>
                                        <div className="pricinglist pr_icon">
                                            <h2 className="os_name">{data.name}</h2>
                                            <div className="app_icon">
                                                <img src={data.image} alt="" className="img-fluid" />
                                            </div>
                                            <p className="credits mb-0">{data.caption}</p>
                                            <div className="pricing_btns">
                                                {data.link.length > 0 && data.link.map((x, i) => {
                                                    return (
                                                        <a href={x.url} className="btn-cmn btn-grn" style={{ textTransform: "none" }} key={i}>
                                                            <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="16" height="16">
                                                                <path fill="#fff" d="M13 8.5l-1.3-1.4L8.9 10V0H7.1v10L4.3 7.1 3 8.5l5 5zM3.6 14.1h8.8V16H3.6z" />
                                                            </svg> {x.format}</a>
                                                    )
                                                })}
                                            </div>
                                        </div>
                                    </div>
                                )
                            })}

                        </div>
                    </div>
                </div>
            </div>

            <div className="pluginfeatures">
                <div className="container">
                    <div className="heading_row type2">
                        <h2>App Features</h2>
                    </div>

                    <div className="row cstm-row">
                        <div className="col-6 col-sm-6 col-md-3 mob-pad0">
                            <div className="fetricn-hldr2">
                                <i className="fetre-icn2"></i>
                                <p>Drag and Drop</p>
                            </div>

                        </div>
                        <div className="col-6 col-sm-6 col-md-3 mob-pad0">
                            <div className="fetricn-hldr2 icon2">
                                <i className="fetre-icn2"></i>
                                <p>High Quality</p>
                            </div>

                        </div>
                        <div className="col-6 col-sm-6 col-md-3 mob-pad0">
                            <div className="fetricn-hldr2 icon3">
                                <i className="fetre-icn2"></i>
                                <p>Bulk Optimization</p>
                            </div>

                        </div>
                        <div className="col-6 col-sm-6 col-md-3 mob-pad0">
                            <div className="fetricn-hldr2 icon4">
                                <i className="fetre-icn2"></i>
                                <p>White labeled</p>
                            </div>

                        </div>
                        <div className="col-6 col-sm-6 col-md-3 mob-pad0">
                            <div className="fetricn-hldr2 icon5">
                                <i className="fetre-icn2"></i>
                                <p>Instant Compress</p>
                            </div>

                        </div>
                        <div className="col-6 col-sm-6 col-md-3 mob-pad0">
                            <div className="fetricn-hldr2 icon6">
                                <i className="fetre-icn2"></i>
                                <p>Social Share</p>
                            </div>

                        </div>
                        <div className="col-6 col-sm-6 col-md-3 mob-pad0">
                            <div className="fetricn-hldr2 icon7">
                                <i className="fetre-icn2"></i>
                                <p>Save to Dropbox</p>
                            </div>

                        </div>
                        <div className="col-6 col-sm-6 col-md-3 mob-pad0">
                            <div className="fetricn-hldr2 icon8">
                                <i className="fetre-icn2"></i>
                                <p>Speed up your website</p>
                            </div>

                        </div>
                    </div>

                </div>
            </div>

            <div className="why-speed-sctn">
                <div className="container">
                    <div className="whyspeedmtr-hldr">
                        <div className="whyspeedmtr-lfttext text-left">
                            <h3>Speed Up Your Website with Compressed Images</h3>
                            <p><strong>Faster Load Times. Better UX. Higher Rankings.</strong></p>
                            <p className="mb-3">Images are often the biggest bottleneck slowing down websites. With our smart image compression, you can:</p>
                            <ul className="bullet_list">
                                <li><strong>Boost page speed</strong> and reduce bounce rates</li>
                                <li><strong>Improve SEO rankings</strong> with faster loading times</li>
                                <li><strong>Enhance user experience</strong> across all devices</li>
                                <li>Save bandwidth without compromising visual quality</li>
                            </ul>
                            <p>Whether you're running an eCommerce store, blog, or portfolio — optimized images are the key to performance.</p>
                            <p><strong>Compress. Upload. Accelerate.</strong></p>
                            <p>Start optimizing your website today with lightning-fast, compressed images.</p>
                        </div>
                        <div className="whyspdmtr-imghldr"> </div>
                        <div className="clearfix"> </div>
                    </div>
                </div>
            </div>

            <Faq />
            <div className="trustedcompany" >
                <div className="container">
                    <p>PNG Compressor works out of the box for these companies</p>
                    <ul className="navbar-nav nav row trusted_slide ">
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                    </ul>
                </div>
            </div>
        </>
    )
}
export default DesktopApp;